declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

const PIXEL_ID = '912972034872110'
let initialized = false

export function initMetaPixel() {
  if (initialized) return

  // Facebook Pixel base code
  const f = window
  const b = document
  const e = 'script'

  if (f.fbq) return

  const n: any = (f.fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'

  b.head.appendChild(t)

  window.fbq('init', PIXEL_ID)
  initialized = true
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Menús Express Ebook',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
